import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

const Close = () => <IonIcon icon={closeOutline} role="img" aria-label="close outline" />;

export default Close;
